<template>
  <div class="search-field search-field--departure">
    <input-field
      :name="translations.departure_airport"
      :readonly="true"
      icon-type="plane-from"
      :value="selectedAirportTexts"
      @focus="$emit('show')"
      :error="validation.departureAirport"
    ></input-field>
    <modal
      class="modal--search-widget"
      :title="translations.departure_airport"
      v-if="show"
      @close="$emit('hide')"
      :close-on-click="true"
      :is-open="isOpen"
    >
      <img
        src="../../../assets/img/icons/icon-plane-departure.svg"
        alt=""
        slot="icon"
      />
      <ul class="modal-view-list">
        <li
          class="modal-view-list__item"
          v-for="(airport, key) in departureAirports"
          :key="key"
        >
          <img
            src="../../../assets/img/traveldestinations/td-airport.svg"
            alt=""
          />
          <checkbox
            :name="airport.text"
            :value="
              seleectedDepartureAirports.indexOf(airport) > -1 ? true : false
            "
            @checked="selectDepartureAirport(airport)"
          ></checkbox>
        </li>
      </ul>
      <div slot="footer" class="modal-view__footer">
        <button
          v-text="translations.ok_btn"
          class="btn btn--success"
          :disabled="validForm && validForm.departureAirport"
          @click="$emit('hide')"
        ></button>
      </div>
    </modal>
  </div>
</template>

<script>
import InputField from "./input-field.vue";
import Modal from "./modal.vue";
import Checkbox from "./checkbox.vue";

export default {
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    value: {
      type: String,
      default: "",
    },
    validation: {
      type: Object,
      default() {
        return {};
      },
    },
    validForm: {
      type: Object,
      default() {
        return {};
      },
    },
    isOpen: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      translations: APP_CONFIG.TRANSLATION.SEARCH_WIDGET,
    };
  },
  methods: {
    selectDepartureAirport(airport) {
      let selectedDepartureAiports = Object.assign(
        [],
        this.seleectedDepartureAirports
      );

      let idx = this.seleectedDepartureAirports.indexOf(airport);
      if (idx > -1) {
        selectedDepartureAiports.splice(idx, 1);
      } else {
        selectedDepartureAiports.push(airport);
      }

      this.$emit(
        "input",
        selectedDepartureAiports.map(({ value }) => value).join(",")
      );
    },
  },
  computed: {
    departureAirports() {
      let airports = this.translations.departure_airports;
      let list = [];
      for (let i in airports) {
        list.push({
          text: airports[i],
          value: i,
        });
      }

      return list;
    },
    seleectedDepartureAirports() {
      let airports = this.value ? this.value.split(",") : [];
      airports = airports
        .map((airportcode) => {
          let airport = this.departureAirports.filter(({ value }) => {
            return airportcode && value.indexOf(airportcode) > -1;
          });

          return airport.length ? airport[0] : null;
        })
        .filter((airport) => airport);

      return [...new Set(airports)];
    },
    selectedAirportTexts() {
      let airports = this.seleectedDepartureAirports;
      if (airports.length > 2) {
        return (
          airports
            .slice(0, 2)
            .map(({ text }) => text)
            .join(",") +
          " (+" +
          (airports.length - 2) +
          ")"
        );
      }

      return airports.map(({ text }) => text).join(",");
    },
  },
  components: {
    Modal,
    InputField,
    Checkbox,
  },
};
</script>